import { CheckCircle2 } from "lucide-react";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1581091212991-8891c7d4bd9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBtYW51ZmFjdHVyaW5nJTIwZmFjaWxpdHl8ZW58MHx8fHwxNzc5NDAyMDM4fDA&ixlib=rb-4.1.0&q=85";

const bullets = [
  "Experiencia técnica en protección de centros de maquinado CNC",
  "Diseño y fabricación de guardas telescópicas a medida",
  "Reparación rápida para minimizar paros de producción",
  "Mantenimiento preventivo para máxima vida útil",
];

export default function About() {
  return (
    <section
      id="nosotros"
      data-testid="about-section"
      className="gf-section bg-white relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left text */}
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-12 h-px bg-[#00B4D8]" />
              <span className="gf-overline">Quiénes Somos</span>
            </div>
            <h2 className="font-display font-black text-[#0A1B35] text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-[1.05] mb-8">
              Ingeniería de protección para
              <span className="text-[#00B4D8]"> mantener tu CNC en marcha.</span>
            </h2>
            <p className="text-slate-600 text-base lg:text-lg leading-relaxed mb-6">
              En <strong className="text-[#0A1B35]">Guarda Flex</strong> nos
              especializamos en sistemas de protección industrial para
              maquinaria CNC. Diseñamos, fabricamos, reparamos y damos
              mantenimiento a guardas telescópicas, fuelles y limpiadores
              que extienden la vida útil y precisión de tus equipos.
            </p>
            <p className="text-slate-600 text-base leading-relaxed mb-10">
              Cada solución es desarrollada con materiales de alta resistencia
              y tolerancias controladas, garantizando un encaje exacto con la
              geometría original de tu centro de maquinado.
            </p>

            <ul className="grid sm:grid-cols-2 gap-4">
              {bullets.map((b) => (
                <li
                  key={b}
                  className="flex items-start gap-3 text-sm text-slate-700"
                >
                  <CheckCircle2
                    size={20}
                    className="text-[#00B4D8] mt-0.5 shrink-0"
                  />
                  <span>{b}</span>
                </li>
              ))}
            </ul>

            <div
              data-testid="about-coverage"
              className="mt-10 bg-[#0A1B35] p-6 border-l-4 border-[#00B4D8]"
              style={{ borderRadius: "2px" }}
            >
              <div className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#00B4D8] mb-2">
                Cobertura local
              </div>
              <p className="text-white/90 text-sm leading-relaxed">
                <strong className="text-white">Servicio local prioritario en Querétaro:</strong>{" "}
                Levantamiento dimensional, diagnóstico o recolección directa en
                parques industriales (El Marqués, Bernardo Quintana, Benito
                Juárez, Finsa, Querétaro Park y zonas de la capital).
              </p>
            </div>
          </div>

          {/* Right image with frame */}
          <div className="lg:col-span-6 relative">
            <div className="relative aspect-[4/5] lg:aspect-[5/6]">
              <div className="absolute -top-4 -left-4 w-24 h-24 border-t-2 border-l-2 border-[#00B4D8]" />
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-2 border-r-2 border-[#00B4D8]" />
              <img
                src={ABOUT_IMG}
                alt="Ingenieros Guarda Flex"
                className="w-full h-full object-cover relative z-10"
                style={{ borderRadius: "2px" }}
              />
              <div className="absolute bottom-6 left-6 right-6 lg:left-8 lg:right-8 z-20 bg-[#0A1B35] p-6 border-l-4 border-[#00B4D8]">
                <div className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#00B4D8] mb-2">
                  Nuestra misión
                </div>
                <p className="text-white text-sm leading-relaxed">
                  Mantener cada centro de maquinado operando al máximo,
                  con protección que resiste el entorno industrial más
                  exigente.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
